module.exports = __webpack_public_path__ + "img/start-icon.6e3e91c0.png";